import React from "react"
import { TextField } from "@material-ui/core"

import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"

import useConditionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useConditionEditor"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import { getMessageReceivedCondition } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type MenuSectionEditorProps = {
	onSave: (chatBotFlowBlockRule: ChatBotFlowBlockRule) => void
	onDelete?: () => void
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	hideChildSelection?: boolean
}

const MenuSectionEditor: React.FC<MenuSectionEditorProps> = (props) => {
	const {
		onSave,
		chatBotFlowBlockRule,
		children,
		hideChildSelection,
		onDelete
	} = props

	const messageReceivedCondition = getMessageReceivedCondition([chatBotFlowBlockRule])
	const conditionEditor = useConditionEditor({ chatBotFlowBlockRule })

	if (!messageReceivedCondition) {
		return null
	}

	return (
		<BlockBodySectionEditor
			title="MENU"
			onSave={() => onSave(conditionEditor.rule)}
			onOpen={conditionEditor.reset}
			onDelete={onDelete}
			hideChildSelection={hideChildSelection}
			AsideDrawerProps={{
				children: (
					<TextField
						variant="outlined"
						placeholder="Novo item do menu"
						value={conditionEditor.retrieveValidationValue(messageReceivedCondition.validationIndex)}
						onChange={(event) => conditionEditor.changeValidationValue(messageReceivedCondition.validationIndex, event.target.value)}
						fullWidth
					/>
				)
			}}
			DeletePopConfirmProps={{
				title: "Excluir menu",
				description: "Tem certeza? Essa ação é irreversível.",
				confirmButtonText: "EXCLUIR"
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default MenuSectionEditor
